import { type GetHookResponse } from '../hooks'
import { interviewKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  type InterviewData,
  type InterviewGetInput,
  type InterviewGetSuccess,
  type InterviewId,
  Logger,
} from '@terros/common'

const logger = new Logger('useInterview')

export function useInterview(interviewId: InterviewId): GetHookResponse<InterviewData> {
  logger.verbose('calling useInterview', interviewId)
  return useTantalimQuery<InterviewGetInput, InterviewGetSuccess, InterviewData>({
    url: '/interview/get',
    queryKey: interviewKey(interviewId),
    input: {
      interviewId,
    },
    convertResponse: (data) => data.interview,
  })
}
